import React, { useMemo } from "react";
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import { LineChartPanel } from "./LineChartPanel";
import { ProcessedLineChartData } from "../utils/useProcessedLineChartData";
import { computeZoomRange } from "../utils/chartDateRange";

interface ChartModalProps {
  open: boolean;
  onClose: () => void;
  processedData: ProcessedLineChartData | null;
  date: string;
  loading: boolean;
}

export function ChartModal({
  open,
  onClose,
  processedData,
  date,
  loading,
}: ChartModalProps) {
  const zoomRange = useMemo(() => {
    if (!processedData || !processedData.xAxisData.length) {
      return null;
    }
    return computeZoomRange(processedData.xAxisData, date, 20);
  }, [processedData, date]);

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-6xl max-h-[90vh] overflow-hidden">
        <div className="flex flex-col gap-4">
          <div className="text-lg font-semibold text-center">
            Chart for {date}
          </div>
          <LineChartPanel
            processedData={processedData}
            loading={loading}
            zoomRange={zoomRange}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
